import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PartyPage from "@/pages/PartyPage";
import AdminPage from "@/pages/AdminPage";
import PhotosPage from "@/pages/PhotosPage";

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PartyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/photos" element={<PhotosPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
